<template>
    <div>

        <div>
            <div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">物品管理</div>
            <el-row style="margin-top: 9px;">
                <div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px;">

                    <el-row style="padding-left: 46px; padding-top: 40px;">

                        <el-col :span="4">
                            <span>物品名称</span>
                            <el-input v-model="condition.goods_name" placeholder="请输入物品名称" style="width: 65%; margin-left: 10px;">
                            </el-input>
                        </el-col>

                        <el-col :span="4" style="margin-left:10px">
                            <span>物品编号</span>
                            <el-input v-model="condition.goods_no" placeholder="请输入物品编号" style="width: 65%; margin-left: 10px;">
                            </el-input>
                        </el-col>

                        <el-col :span="4" style="margin-left:10px">
                            <span>规格型号</span>
                            <el-input v-model="condition.goods_model" placeholder="请输入规格型号" style="width: 65%; margin-left: 10px;">
                            </el-input>
                        </el-col>

                        <el-col :span="4" style="margin-left:10px">
                            <span>物品类型</span>
                            <el-select v-model="condition.type_id" placeholder="请选择物品类型" clearable style="width:65%;margin-left: 10px;">
                                <el-option v-for="item in lxList" :key="item.id" :label="item.data"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                        
                            <div style="float:right">
                                <el-button @click="Find"
                                    style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
                                    查询</el-button>
                                <el-button @click="Del(null)"
                                    style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
                                    删除</el-button>
                                <el-button style="width: 85px; border: 1px solid #006E4B; color: #006E4B;" @click="AddFrom">
                                    新增</el-button>
                            </div>

                    </el-row>

                    <el-row style="margin: 0px 2%; margin-top: 10px;">
                        <el-row>
                            <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
                                :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" height="595"
                                tooltip-effect="dark" style="width: 100%;" @selection-change="handleSelectionChange">
                                <el-table-column type="selection" width="55">
                                </el-table-column>
                                <el-table-column align="center" label="序号">
                                    <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
                                </el-table-column>
                                <el-table-column prop="goods_name" align="center" label="物品名称"></el-table-column>
                                <el-table-column prop="goods_no" align="center" label="物品编号"></el-table-column>
                                <el-table-column prop="type_name" align="center" label="物品类型"></el-table-column>
                                <el-table-column prop="goods_model" align="center" label="规格型号"></el-table-column>
                                <el-table-column prop="model_quantity" align="center" label="物品数量"></el-table-column>
                                <el-table-column prop="model_colour" align="center" label="颜色"></el-table-column>
                                <el-table-column prop="model_weight" align="center" label="重量"></el-table-column>
                                <el-table-column prop="model_brand" align="center" label="品牌"></el-table-column>
                                <el-table-column align="center" label="操作">
                                    <template slot-scope="scope">
                                        <img src="../../../assets/编辑.png" @click="Edit(scope.row)" />
                                        <img src="../../../assets/删除.png" @click="Del(scope.row.id)" />
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-row>
                        <el-row style="margin-top: 10px; text-align: center;">
                            <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                                layout=" prev, pager, next, jumper" :total="total">
                            </el-pagination>
                        </el-row>
                    </el-row>
                </div>
            </el-row>
        </div>

        <div>
            <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false"
                :center="true">
                <add ref="add"></add>
            </el-dialog>
        </div>

    </div>
</template>

<script>
    import add from './WpGl_add.vue';

    import axios from "axios";
    export default {
        components: {
            add: add,
        },
        data() {
            return {
                //列表相关
                page_num: 1,
                page_size: 10,
                total: 0,
                tableData: [],
                // 物品类型
                lxList:[],
                ids: [],
                from:{
                    id:"",
                    goods_name: "",
                    goods_no: "",
                    type_id: "",
                    goods_model: "",
                    model_colour: "",
                    model_brand: "",
                    model_weight: "",
                    model_quantity: "",
                },
                condition:{
                    goods_name:'',
                    goods_no:'',
                    type_id:'',
                    goods_model:'',
                },
                //页面相关
                dialogVisible: false,
                dialogTitle: "",
                
            };
        },
        methods: {
            //查询
            async Find() {
            var url = 'GoodS/selectAll';
            var record = {
                page_num: this.page_num,
                page_size: this.page_size,
                goods_name:this.condition.goods_name,
                goods_no:this.condition.goods_no,
                type_id:this.condition.type_id,
                goods_model:this.condition.goods_model,
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === '-2000') {
                this.$message.error('服务器未响应！请稍后重试');
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                this.tableData = data.list;
                } else {
                this.$message.warning('请求失败！请稍后重试');
                }
            }
            },
            Return() {
                this.dialogVisible = false;
                this.dialogTitle = "";
            },
            AddFrom() {
                this.trash();
                this.dialogVisible = true;
                this.dialogTitle = "新增";
            },
            Edit(e) {
                this.trash();
                this.dialogVisible = true;
                this.dialogTitle = "编辑";
                this.from.id = e.id;
                this.from.goods_name = e.goods_name;
                this.from.goods_no = e.goods_no;
                this.from.type_id = e.type_id;
                this.from.goods_model = e.goods_model;
                this.from.model_colour = e.model_colour;
                this.from.model_brand = e.model_brand;
                this.from.model_weight = e.model_weight;
                this.from.model_quantity = e.model_quantity;
            },
            // 操作删除
            async Del(e) {
                var ids;
                if (e === null || e === "" || e === undefined) {
                    if (this.ids === null || this.ids.length <= 0) {
                        this.$message.warning("请先选择操作数据！");
                        return false;
                    }
                    ids = this.ids;
                } else {
                    ids = [e];
                }
                
                var url = "GoodS/del";
                var record = {
                    ids: ids,
                };
                var data = await this.$globals.AxiosPost(url, record);
                if (data === "-2000") {
                    this.$message.error("服务器未响应！请稍后重试");
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.$message.success(data);
                        this.trash();
                        this.Find();
                    } else {
                        this.$message.warning(data);
                    }
                }
            },
            //清除数据
			trash() {
                this.from.id = '';
                this.from.goods_name = '';
                this.from.goods_no = '';
                this.from.type_id = '';
                this.from.goods_model = '';
                this.from.model_colour = '';
                this.from.model_brand = '';
                this.from.model_weight = '';
                this.from.model_quantity = '';
            },
            //返回
            Return() {
                this.dialogVisible = false;
                this.Find();
            },

        },
        async created() {
            this.Find();
            //物品类型
            var lxList = await this.$globals.AxiosPost("/dictionaries/selectFind", {
            data_grouping: "article_type"
            });
            this.lxList = lxList.data;
        }
    }
</script>

<style scoped="scoped">
    >>>.el-button:hover {
        background-color: #FFFFFF;
    }

    >>>.el-button:focus {
        background-color: #FFFFFF;
    }

    >>>.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #006E4B;
    }

    >>>.el-input__inner:focus {
        border-color: #006E4B;
    }

    >>>.el-select .el-input.is-focus .el-input__inner {
        border-color: #006E4B;
    }

    >>>.el-checkbox__input.is-checked .el-checkbox__inner,
    >>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #006E4B;
        border-color: #006E4B;
    }

    >>>.el-checkbox__inner:hover {
        border-color: #006E4B;
    }
</style>



// WEBPACK FOOTER //
// WpGl.vue?b4d57882